export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "fresh-cloud.au.auth0.com",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "9z3c6gEftWVHXWW82jR72UyTd7Fmp8oR",
  redirectUri: window.location.origin,
};

export const dummyUser = {
  email: "testbox@myfresh.cloud",
  name: "Test Box",
  role: "admin",
  organisations: [{ id: "1", name: "My Fresh" }],
};
